import { lazy } from 'react';

export const AttackSimDetail = lazy(() =>
  import('./pages/SimulationDetail').then((module) => ({ default: module.SimulationDetail }))
);

export const AttackSimCreate = lazy(() =>
  import('./pages/CreateSimulation').then((module) => ({ default: module.CreateSimulation }))
);
